import React, { Component, PropTypes } from 'react';
import { PaymentActions } from 'actions';
import Css from 'Css';
import Visa from 'Cio/Assets/Visa';
import MasterCard from 'Cio/Assets/MasterCard';
const { Units } = Css;

const css = oxygenCss({
  root: {
    position: 'relative',
    display: 'flex',
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: '#DDDDDD',
    flexDirection: 'row',
    margin: `${Units.base * 4}px auto`,
    minWidth: 320,
    // maxWidth: 640,
    '@phone': {
      // flexDirection: 'column'
    }
  },
  delayed: {
    padding: Units.base * 2,
    cursor: 'pointer',
    flexGrow: 1,
    flexShrink: 0,
    borderStyle: 'none solid none none',
    borderWidth: 1,
    borderColor: '#DDDDDD',
    '@phone': {
      padding: Units.base * 2
    },
    '>IMG': {
      marginBottom: Units.base * 2
    },
    ':hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.1)'
    }
  },
  card: {
    textAlign: 'center',
    cursor: 'pointer',
    padding: Units.base * 2,
    '@phone': {
      padding: Units.base * 2
    },
    flexGrow: 1,
    flexShrink: 0,
    ':hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.1)'
    }
  },
  cardChooser: {
    textAlign: 'center',
    padding: Units.base
  },
  creditCard: {
    margin: Units.base
  }
});

class PaymentMethodChooser extends Component {
  static propTypes = {
    onSetMethod: PropTypes.func
  };

  static contextTypes = {
    getIntlMessage: PropTypes.func
  };

  setMethod(method) {
    const { onSetMethod } = this.props;
    if (onSetMethod) {
      onSetMethod(method);
    } else {
      PaymentActions.change({ method });
    }
  }

  render() {
    const { getIntlMessage } = this.context;
    return (
      <div className={css.root}>
        <div
          className={css.delayed}
          onTouchTap={this.setMethod.bind(this, 'invoice')}
        >
          <div className={css.cardChooser}>
            <img src="https://cdn.klarna.com/1.0/shared/image/generic/logo/sv_se/basic/blue-black.png?width=128" />
            <br />
            {getIntlMessage('payment.klarna.invoice')}
          </div>
        </div>
        <div
          className={css.card}
          onTouchTap={this.setMethod.bind(this, 'creditcard')}
        >
          <div className={css.cardChooser}>
            <Visa className={css.creditCard} />
            <MasterCard className={css.creditCard} />
            <br />
            {getIntlMessage('payment.creditCard')}
          </div>
        </div>
      </div>
    );
  }
}

export default PaymentMethodChooser;



// WEBPACK FOOTER //
// ./src/js/components/Store/PaymentMethodChooser.js